jQuery(document).ready(function($) {
    const base = "gc-product-item";

	$(`.${base}__button`).click(function(e) {
		e.preventDefault();
		$(this).attr('data-loading', 'true')

		$(`.${base}__message`).hide();

		const url = $(this).parent().data('url');
		const quantity = $(this).parent().find('input[name=quantity]').val();
		const product_id = $(this).parent().find('input[name=product_id]').val();

		$.ajax({
			url : url,
			type: 'POST',
			data : {
				action: 'addToCart',
				product_id: product_id,
				quantity: quantity
			}
		}).done(responseRaw => {
			$(this).attr('data-loading', 'false')
			const response = JSON.parse(responseRaw);
			showToast(response.message);
		});
	});
});